module.exports = __webpack_public_path__ + "fonts/700-normal-cyrillic.1877b8a.woff2";